module.exports = __webpack_public_path__ + "static/media/evangelium.e8a60ddf.jpg";